'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/quarters', null, {
            get: {method: 'GET'},
            tree: {url: 'api/quarters/tree', method: 'GET'},
        });
    }];